import "../assets/styles/views/auth-code.scss";
import { useLocation, useOutletContext, NavLink } from "react-router-dom";
import { checkSession } from "../utils/session";
import { setCookie } from "../utils/cookie";
import { useEffect, useState } from "react";
import { user_check_code, user_send_code } from "../utils/endpoints";

export default function AuthCode() {
  const location = useLocation();
  const [context, setContext] = useOutletContext();
  const [blurred_mail, setBlurredMail] = useState();

  useEffect(() => {
    if (location.state.email) {
      let mail_parts = location.state.email.split("@");
      mail_parts.splice(1, 0, "@");
      mail_parts[0] =
        mail_parts[0].charAt(0) + "*".repeat(mail_parts[0].length - 1);

      let mail_blur = "";
      mail_parts.map((item) => {
        mail_blur += item;
      });
      setBlurredMail(mail_blur);
    }

    [...Array(5)].map((item, index) => {
      let input = document.querySelector(`[name=auth_code_${index}]`);
      if (input) {
        if (index === 0) input.focus();

        input.addEventListener("paste", (e) => {
          e.preventDefault();

          let paste_text = (e.clipboardData || window.clipboardData)
            .getData("text")
            .replace(/\D/g, "")
            .trim();

          if (paste_text.length === 5) {
            [...Array(5)].map((sub_item, sub_index) => {
              let sub_input = document.querySelector(
                `[name=auth_code_${sub_index}]`
              );
              if (sub_input) sub_input.value = paste_text.charAt(sub_index);
            });
          }
        });
      }
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (location.state.email) {
      let final_code = "";

      [...Array(5)].map((item, index) => {
        final_code += e.target[`auth_code_${index}`].value;
      });

      if (final_code && location.state.session) {
        let response = await context.httpRequest(
          "get",
          `${user_check_code}/${final_code}`,
          null,
          location.state.session.token
        );
        if (response.result) {
          setContext({ session: location.state.session });
          setCookie("session_cookie", JSON.stringify(location.state.session));
          checkSession(setContext, context.navigateUrl, context.httpRequest);
        }
      } else {
        context.openMessage("danger", "Il codice inserito non è valido");
      }
    }
  };

  const handleChangeFocus = (e, field_index) => {
    if (e.target.value.length > 1) {
      e.target.value = e.target.value.slice(-1);
    }
    if (e.target.value && field_index < 4) {
      document.querySelector(`[name=auth_code_${field_index + 1}]`).focus();
    }
  };

  const handleBackSpace = (e, field_index) => {
    const key = e.key;
    if (
      (key === "Backspace" || key === "Delete") &&
      field_index > 0 &&
      !e.target.value
    ) {
      document.querySelector(`[name=auth_code_${field_index - 1}]`).focus();
    }
  };

  const sendNewCode = async () => {
    if (location.state?.session) {
      let response = await context.httpRequest(
        "get",
        user_send_code,
        null,
        location.state.session.token
      );
      if (response.result)
        context.openMessage(
          "success",
          "Abbiamo inviato un nuovo codice alla sua email."
        );
    }
  };

  return (
    <section className="auth-code w-100 mt-md-5 main-panel p-3">
      <h1 className="m-0 text-center">Verifica identità</h1>
      <p className="mt-4 mb-3 d-block text-center">
        Abbiamo inviato un codice di verifica all'e-mail {blurred_mail}
      </p>
      <form onSubmit={(e) => handleSubmit(e)} className="text-center">
        <input
          onChange={(e) => handleChangeFocus(e, 0)}
          onKeyDown={(e) => handleBackSpace(e, 0)}
          max="9"
          min="0"
          maxLength="1"
          className="me-1 text-center"
          name="auth_code_0"
          type="number"
          required
        />
        <input
          onChange={(e) => handleChangeFocus(e, 1)}
          onKeyDown={(e) => handleBackSpace(e, 1)}
          max="9"
          min="0"
          maxLength="1"
          className="mx-1 text-center"
          name="auth_code_1"
          type="number"
          required
        />
        <input
          onChange={(e) => handleChangeFocus(e, 2)}
          onKeyDown={(e) => handleBackSpace(e, 2)}
          max="9"
          min="0"
          maxLength="1"
          className="mx-1 text-center"
          name="auth_code_2"
          type="number"
          required
        />
        <input
          onChange={(e) => handleChangeFocus(e, 3)}
          onKeyDown={(e) => handleBackSpace(e, 3)}
          max="9"
          min="0"
          maxLength="1"
          className="mx-1 text-center"
          name="auth_code_3"
          type="number"
          required
        />
        <input
          onChange={(e) => handleChangeFocus(e, 4)}
          onKeyDown={(e) => handleBackSpace(e, 4)}
          max="9"
          min="0"
          maxLength="1"
          className="ms-1 text-center"
          name="auth_code_4"
          type="number"
          required
        />
        <span className="mt-4 text-center d-block">
          Non hai ricevuto il codice?{" "}
          <strong onClick={() => sendNewCode()} className="new-code-button">
            Invia un nuovo codice
          </strong>
        </span>
        <button className="mt-4 p-3 w-100 q8-blue-button" type="submit">
          VERIFICA IL TUO CODICE
        </button>

        <NavLink className="mt-4 text-end d-block" to="/login">
          Torna alla Log in
        </NavLink>
      </form>
    </section>
  );
}
